import { render, staticRenderFns } from "./courseInfo.vue?vue&type=template&id=53c41607&scoped=true"
import script from "./courseInfo.vue?vue&type=script&lang=js"
export * from "./courseInfo.vue?vue&type=script&lang=js"
import style0 from "./courseInfo.vue?vue&type=style&index=0&id=53c41607&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c41607",
  null
  
)

export default component.exports